import React, { useCallback, useMemo } from "react";

import { useResult } from "2g-grid";
import { Theme as WidgetTheme } from "2g-widget";
import { Icons } from "2g-icons";

import { ADMIN } from "b2b/api/paths";
import { PATHS } from "b2b/constants";
import { useRedirect } from "b2b/hooks";
import useMessages from "./i18n/useMessages";
import useColumns from "./useColumns";

export default function useZdrojeGrid() {
  const columns = useColumns();
  const { title, add } = useMessages();
  const redirect = useRedirect();

  const redirectToZdroj = useCallback(
    id => {
      redirect(PATHS.ADMINISTRACE.ZDROJ, {
        id
      });
    },
    [redirect]
  );

  const handleRowClick = useCallback(
    ({ dataRow }) => {
      redirectToZdroj(dataRow.id);
    },
    [redirectToZdroj]
  );

  const handleAddClick = useCallback(() => {
    redirectToZdroj();
  }, [redirectToZdroj]);

  const titleActions = useMemo(
    () => ({
      add: () => (
        <WidgetTheme.HeaderAction key="add" onClick={handleAddClick}>
          <Icons.Plus />
          <span>{add()}</span>
        </WidgetTheme.HeaderAction>
      )
    }),
    [redirectToZdroj]
  );

  return useResult({
    title: title(),
    moduleKey: "zdrojeGrid",
    url: ADMIN.zdroje(),
    method: "get",
    columns,
    collapsed: true,
    onRowClick: handleRowClick,
    showFilterDescription: false,
    selectable: false,
    sortable: true,
    loadOnInit: true,
    titleActions
  });
}
